import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, UserLabelsService, Alert) {
        this.$state = $state;
        this.UserLabelsService = UserLabelsService;
        this.Alert = Alert;
		this.queryLabelIds=(labelInRow)=> {
        	return labelInRow.id !== this.userLabelId;
    	}
    }

    $onInit() {
        if (!this.users.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }
		
        this.st = new SmartTable();
		this.st.displayedItems=angular.copy(this.labels);
    }

	
    copy() {
        const userIds = this.users.map(({id}) => id);

        this.isSaving = true;
		var companyId=this.companyId;
		var labelId=this.userLabelId;
        this.UserLabelsService
          //  .addCompanyUsers({companyId,labelId}, userIds).$promise
			.copyCompanyUsersToLabels({companyId,labelId},{ aIds:userIds,bIds:this.st.selectedIds}).$promise
            .then(() => this.$state.go('^', {userLabelId:labelId}, {reload: '^.^'}))
            .then(() => this.Alert('success', 'company.user-directories.saaspass-users.user-labels.users.copy.copied'))
			.catch((error) =>{ 
						this.Alert('danger', error.data.message)})
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/copy/copy-users-to-labels.controller.js